const isNullOrEmpty = (value: string | undefined) => {
    return !value || value === '';
};

export default isNullOrEmpty;
